import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'Ramy Gamal | SWE', // e.g: 'Name | Developer'
  lang: 'en', // e.g: en, es, fr, jp
  description: 'Welcome to Ramy Gamal Portifolio', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: 'Hi, I\'m',
  name: 'Ramy',
  subtitle: 'Software Engineer',
  cta: '',
};

// ABOUT DATA
export const aboutData = {
  img: 'personalPhoto.jpg',
  paragraphs: [
    `I am an enthusiastic, hardworking Egyptian software engineer who have the combination of strong academic
  background, concepts knowledge and maintaining practical experience by developing projects
  which helped to adapt to changes quickly and to be able to work either individually or in a team environment.`,

    '2020 graduate from Software Engineering department at Ain Shams university with 3.87 Cumulative GPA and being top student on class.',

    'I love contributing to open source projects and organising events and hackathons. Also I have photography and graphic design skills.'
  ],
  resume: 'https://bit.ly/RaamyyResume', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'GP.PNG',
    title: 'Automatic Video Subtitling and Translation System',
    infos: [
      `Graduation Project.`,
      `A system that uses machine learning and machine translation to convert the speech to text, translate it to arabic and then display the translated text as timed subtitles on the video.`,
      `We developed our python translation model using our own dataset and then integrated with electron application to provide user interface to the user so he can manipulate the subtitles.`,
    ],
    url: 'https://drive.google.com/file/d/1j-uREOBBNoBZynnuMKxZ9Acdjl02jlfk/view',
    url_cta: 'Project Thesis'
    //repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'bitsGallery.PNG',
    title: 'Bits Gallery Website',
    infos: [
      'A website that helps Bits Gallery customers to browse available sticker products and offers.',
      'Built using NodeJS, react and firebase',
    ],
    url: 'https://www.bitsgallery.me/',
    //repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'YalaNotlobAkl.PNG',
    title: 'Yalla Notlob Akl',
    infos: [
      `When you are eating with a large group there is a nightmare called distributing money. With this web application it eases the process of calculating each person's own reciept.`,
      'Built using .Net Core Web App',
    ],
    url: 'https://yalla-notlob-akl.herokuapp.com/',
    //repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: '',
  btn: '',
  email: 'ramyeg26@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'envelope',
      url: 'mailto:ramyeg26@gmail.com',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://www.github.com/raamyy',
    },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/raamyy',
    },
    {
      id: nanoid(),
      name: 'stack-overflow',
      url: 'https://www.stackoverflow.com/users/8142985/raamyy',
    },

  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};

export const workExperienceData = [
  {
    id: nanoid(),
    date: 'Oct 2021 - Current',
    companyName: 'Gameball',
    workTitle: 'Software Engineer',
    icon: 'briefcase',
    link: 'https://gameball.co/',
    details: `
    As a software engineer, my role is to build and maintain the Gameball platform.
    I am responsible for the development of the backend and frontend of the platform.
    Tech stack: ASP.NET Core, PostgreSQL Database, AngularJS.
    `
  },
  // {
  //   id: nanoid(),
  //   date: 'Jun-Sep 2021',
  //   companyName: 'Gameball',
  //   workTitle: 'Part-time Software Engineer',
  //   icon: 'briefcase',
  //   link: 'https://gameball.co/',
  //   details: `
  //   Part of the devlopment team for university management system.
  //    Responsible for building new screens and solving bugs in the system. 
  //   Tech Stack: ASP.NET MVC, KendoUI.
  //   `
  // },
  {
    id: nanoid(),
    date: 'Jan-May 2021',
    companyName: 'Ain Shams University',
    workTitle: 'Full Stack Software Developer',
    icon: 'briefcase',
    details: `
    Part of the development team for university management system.
     Responsible for building new screens and solving bugs in the system. 
     Initiated QR code attendance system for university exams.
    Tech Stack: ASP.NET MVC, KendoUI.
    `,
    link: 'http://ums.asu.edu.eg/'
  },
  {
    id: nanoid(),
    date: 'Sep 2020-2021',
    companyName: 'Faculty of Computer and Information Science',
    workTitle: 'Teaching Assistant',
    icon: 'briefcase',
    details: 'Responsible for teaching and guiding undergraduate students. Taught Object Oriented Programming and Data Structures.'
  },
  {
    id: nanoid(),
    date: '2020',
    companyName: 'Ain Shams University - Faculty of Computer Science',
    workTitle: 'Graduation',
    icon: 'graduation-cap',
    details: 'Graduated from Software Engineering department with cumulative Excellent 3.877 GPA and being TOP student on class. 💪'
  },

];